module.exports = __webpack_public_path__ + "img/category-skill-game.41bfccc4.png";